module.exports = "<a [routerLink]=\"[inputWhere]\"  ><i class=\"fa {{kind}} {{size}}\" aria-hidden=\"true\">\n\t\n</i></a>"